import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=4f0fc3a1"
import script from "./SensitiveWords.vue?vue&type=script&lang=js"
export * from "./SensitiveWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports